import { MrfiktivHttpClientProvider } from "@/services/mrfiktiv/mrfiktiv-http-client.provider";
import { Tag } from "../v1/Tag";
import {
  MrfiktivCreateTagDtoGen,
  MrfiktivTagControllerFindAllByPartnerIdParamsGen,
  MrfiktivTagViewModelGen,
  MrfiktivUpdateTagDtoGen
} from "../v1/data-contracts";
import { BackendResourceEnum } from "@/store/enum/authResourceEnum";

/**
 * Communicate with tag API
 */
class TagService {
  mrfiktivProxy: Tag;

  /**
   * Construct service
   */
  constructor(mrfiktivHttpClientProvider: MrfiktivHttpClientProvider) {
    this.mrfiktivProxy = new Tag(mrfiktivHttpClientProvider.client());
  }

  /**
   * Create an tag
   */
  async create(partnerId: string, data: MrfiktivCreateTagDtoGen) {
    const tag = (await this.mrfiktivProxy.tagControllerCreate(partnerId, data)).data;

    return tag;
  }

  /**
   * Get all tag
   *
   */
  async get(data: MrfiktivTagControllerFindAllByPartnerIdParamsGen) {
    /**
     * If a tag is available for all resources, we store an empty array in the backend.
     * Because we cant do an or filter in the pagination, there is a special case for the resource filter.
     * If the resource filter is set to $eq, we send it as a special property in the request.
     * The backend will build a special filter for this case.
     */
    const resourceKey: keyof Pick<MrfiktivTagViewModelGen, "resources"> = "resources";
    const resourceEqFilter = data.filter?.find(
      (filter) => filter.key === resourceKey && (!filter.operation || filter.operation === "$eq")
    );
    const filterWithoutResource = data.filter?.filter(
      (filter) => filter.key !== resourceKey || (filter.operation && filter.operation !== "$eq")
    );

    if (resourceEqFilter) {
      data.resource = resourceEqFilter.value as BackendResourceEnum;
      data.filter = filterWithoutResource;
    }

    const tags = (await this.mrfiktivProxy.tagControllerFindAllByPartnerId(data)).data;

    return tags;
  }

  /**
   * Get a tag
   */
  async getOne(partnerId: string, tagId: string) {
    const tag = (await this.mrfiktivProxy.tagControllerFindOne(partnerId, tagId)).data;

    return tag;
  }

  /**
   * Update a tag
   */
  async update(partnerId: string, tagId: string, data: MrfiktivUpdateTagDtoGen) {
    const tag = (await this.mrfiktivProxy.tagControllerUpdate(partnerId, tagId, data)).data;

    return tag;
  }

  /**
   * Delete a tag
   */
  async delete(partnerId: string, tagId: string) {
    const tag = (await this.mrfiktivProxy.tagControllerRemove(partnerId, tagId)).data;

    return tag;
  }
}

/**
 * Communicate with tag API
 */
export default new TagService(new MrfiktivHttpClientProvider());
